import React, {useState, useEffect, useRef} from 'react';
import ProtectedRoute from '../../../routes/protected';
import SideBarCompanyManagement from '../../../components/sidebars/sidebarCompanyManagement';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import companyService from '../../../services/data/company.service';
import { Sidebar } from 'primereact/sidebar';
import { AutoComplete } from "primereact/autocomplete";
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import 'moment/locale/pt-br'
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
import currencyFormat from '../../../helpers/currencyFormat';
import FormImportJobPositionXls from '../../../components/settings/forms/formImportJobPositionXls';
import VerifyPerms from '../../../context/userAccess';
import { Chip } from 'primereact/chip';
import { Toast } from 'primereact/toast';


export default function JobPositionList() {
    const [selection, setSelection] = useState();
    const [showSidebar, setShowSidebar] = useState(false);

    const [itemsList, setItemsList] = useState([]);
    const [page, setPage] = useState(1)
    const [search , setSearch] = useState('')
    const [items, setItems] = useState([]); // autocomplete
    const [itemsCount, setItemsCount] = useState(0);

    const [worksheet, setWorksheet] = useState('')

    const navigate = useNavigate()
    const modalRef = useRef()

    const toast = useRef(null);

    const hideModal = () => {
        const modalEl = modalRef.current
        const bsModal= bootstrap.Modal.getInstance(modalEl)
        bsModal.hide()
    }

    useEffect(() => {
        listItems()
    }, [page]);

    const searchItems = (event) => {
        if (event.query.length > 2) {

            companyService.autoCompleteJobPosition(event.query).then((response) => {
                
                let resultTitle = response.map((item) => item.title + ' - ' + item.internal_code)
                let subCompanyResult = response.map((item) => item.subcompany)
                subCompanyResult = new Set(subCompanyResult) //remove duplicados
                setItems([...resultTitle, ...subCompanyResult])
                
            })
            .catch((error) => {
                console.log(error.response.data)
            });

        }
    }

    function listItems() {
        companyService.listJobPosition(page).then((response) => {
            setItemsList(response)
            setItemsCount(response.count)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    function filterItems() {
        companyService.listJobPosition(page, search.split('-')).then((response) => {
            setItemsList(response)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    function cleanSearch() {
        setSearch('')
        listItems() 
    }

    function addPage() {
        setPage(page + 1)
    }

    function subPage() {
        setPage(page - 1)
    }

    function editItem() {
        return navigate(`/settings/jobposition/management/${selection.id}/edit/`)
    }

    function addItem() {
        return navigate(`/settings/jobposition/management/${selection.id}/add/`)
    }

    useEffect(() => {

        getWorksheet()

    }, [])

    function getWorksheet() {

        let data = {
            key: 'templates/JobPosition.xlsx'
        }

        companyService.downloadObject(data).then((response) => {
            setWorksheet(response.data)
        }).catch((error) => {
            console.log(error.response)
        });

    }

    function exportJobPositions() {

        toast.current.show({ severity: 'info', summary: 'Aguarde', detail: 'Exportando Posições...', life: 4000 });

        companyService.exportJobPositions().then((response) => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: response.message, life: 4000 });
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 10000 });
        });
    }

    return (
        <ProtectedRoute>

<Toast ref={toast} position="top-right" />

            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <SideBarCompanyManagement />
                    <div className="col-xs-10 col-sm-9 col-md-9 col-xl-10 p-0 formMarginBottom">
                        <div className='col text-bg-green p-3'>
                            <span className="fs-6 fw-bold">Posições de Trabalho</span>
                        </div>
                        {
                            VerifyPerms(['add_jobposition', 'change_jobposition', 'delete_jobposition', 'view_jobposition']) ?
                            <>
                            <div className="row m-3 p-3 justify-content-start">
                                <div className='col bg-white border-clean pb-5 ps-3'>
                                    
                                    <div className="pt-4 d-flex mb-4">
                                        <div className='col'>
                                            <span className='font120 fw-bold '>
                                                Posições de Trabalho
                                            </span>
                                            <button id='dbm-addJob' className="btn btn-sm no-caret dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                <FontAwesomeIcon className='text-green font150' icon={solid('plus-circle')} />
                                            </button>
                                            <ul className="dropdown-menu border headerBorder font1em" aria-labelledby="dbm-addJob">
                                                <li>
                                                    <button className="dropdown-item text-default" data-bs-toggle="modal" data-bs-target="#formImport">
                                                        Adicionar Posições
                                                    </button>
                                                </li>

                                                {
                                                    itemsCount > 0  ?
                                                    <li>
                                                        <button className="dropdown-item text-default" onClick={exportJobPositions}>
                                                            Exportar Posições
                                                        </button>
                                                    </li>
                                                    : null
                                                }
                                            </ul>
                                        </div>
                                        
                                        <div className='col'>
                                            <div className='d-flex'>

                                                <div className='p-inputgroup'>
                                                    <AutoComplete inputClassName='input-search-radius' placeholder='Buscar Posições pelo Título, Código ou Organização' value={search} suggestions={items} completeMethod={searchItems} onChange={(e) => setSearch(e.value)} />
                                                    <button className='btn btn-success button-search-radius' onClick={filterItems}>
                                                        <FontAwesomeIcon icon={solid('magnifying-glass')} />
                                                    </button>
                                                </div>
                                                {
                                                    search ?
                                                    <button className='btn btn-sm btn-link fw-bold font1em text-grey text-decoration-none' onClick={() => cleanSearch()}>
                                                        Limpar
                                                    </button>
                                                    : null
                                                }
                                                
                                            </div>
                                            
                                        </div>
                                        <hr className='hr-border' />
                                    </div>

                                    <p className='text-end'><strong>{itemsCount}</strong> Posições cadastradas</p>

                                    {
                                        itemsList && itemsList.results && itemsList.results.length > 0 ?
                                        <>
                                        <table className='table table-borderless thover borderBottom mt-3'>
                                            <thead className='borderBottom'>
                                                <tr>
                                                    <th>
                                                        Título da Posição
                                                    </th>
                                                    <th className='text-center'>
                                                        Código
                                                    </th>
                                                    <th className='text-center'>
                                                        Organização
                                                    </th>
                                                    <th className='text-center'>
                                                        Cargo
                                                    </th>
                                                    <th className='text-center'>
                                                        Departamento
                                                    </th>
                                                    <th className='text-center'>
                                                        Centro de Custo
                                                    </th>
                                                    <th className='text-center'>
                                                        Faixa Salarial
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    itemsList.results.map((item, index) =>
                                                        <tr key={index}>
                                                            <td className="align-middle">
                                                                <span className='text-green fw-bold text-capitalize text-decoration-none' style={{'cursor': 'pointer'}} onClick={() => {setSelection(item); setShowSidebar(true)}}>
                                                                    {item.title}
                                                                </span>
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                {item.internal_code}
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                {item.subcompany.title}
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                {item.internaljobtitle.title}
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                {item.department.title}
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                {item.costcenter.title}
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                {item.paylevel && item.paylevel.range ? (
                                                                    <>
                                                                        {
                                                                            item.paylevel.range.filter((range, index) => index === 0).map(obj => 
                                                                                currencyFormat(obj.value)
                                                                            )
                                                                        }
                                                                        <span> - </span>
                                                                        {
                                                                            item.paylevel.range.filter((range, index) => index === 2).map(obj => 
                                                                                currencyFormat(obj.value)
                                                                            )
                                                                        }
                                                                    </>
                                                                ) : (
                                                                    <span className="text-muted">-</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                        <div className='float-end'>
                                            <nav>
                                                <ul className='pagination pagination-sm'>
                                                    <li className='page-item'>
                                                        { 
                                                            itemsList.previous ? 
                                                            <span onClick={subPage} className='page-link text-default'>
                                                                <FontAwesomeIcon className='' icon={solid('angle-left')} />
                                                            </span>
                                                            :
                                                            <span className='page-link text-grey disabled'>
                                                                <FontAwesomeIcon className='' icon={solid('angle-left')} />
                                                            </span>
                                                        }
                                                    </li>
                                                    <li className='page-item'>
                                                        {
                                                            itemsList.next ?
                                                            <span onClick={addPage} className='page-link text-default'>
                                                                <FontAwesomeIcon className='' icon={solid('angle-right')} />
                                                            </span>
                                                            :
                                                            <span className='page-link text-grey disabled'>
                                                                <FontAwesomeIcon className='' icon={solid('angle-right')} />
                                                            </span>
                                                        }
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                        </>

                                        : null
                                    }
                                </div>
                                <div className="card flex justify-content-center">
                                    <Sidebar className="w-50" visible={showSidebar} position="right" onHide={() => {setShowSidebar(false); setSelection('')}}>
                                    {
                                            selection ?
                                            <>
                                            {
                                            <div>
                                                <p className='lead fw-bold text-default text-capitalize'>
                                                    {selection.title} <small className='text-grey fw-normal'>({selection.internal_code})</small>
                                                </p>
                                                
                                                <div>
                                                    <button className='btn btn-sm btn-outline-success btn-rounded px-3 py-1 m-1' onClick={editItem} >
                                                        <FontAwesomeIcon icon={solid('edit')} /> Editar
                                                    </button>

                                                    <button className='btn btn-sm btn-outline-success btn-rounded px-3 m-1' onClick={addItem}>
                                                        <FontAwesomeIcon icon={solid('plus-circle')} /> Adicionar Posição Abaixo
                                                    </button>
                                                </div>
                                                <hr/>
                                                <div className='py-2'>
                                                    <strong>Criado em:</strong> {moment(selection.created).format("DD-MMM-YYYY")} 
                                                </div>
                                                <div className='py-2'>
                                                    <strong>Nº de Posições Esperadas:</strong> {selection.expected_positions} 
                                                </div>
                                                <div className='py-2'>
                                                    <strong>Organização:</strong> {selection.subcompany.title} 
                                                </div>
                                                <div className='py-2'>
                                                    <strong>Cargo:</strong> {selection.internaljobtitle.title} 
                                                </div>
                                                <div className='py-2'>
                                                    <strong>Departamento:</strong> {selection.department.title} 
                                                </div>
                                                <div className='py-2'>
                                                    <strong>Centro de Custo:</strong> {selection.costcenter.title} 
                                                </div>
                                                {
                                                    selection.paylevel ?
                                                    <>
                                                    <div className='py-2'>
                                                        <strong>Estrutura de Salário:</strong> {selection.paylevel.structure.title}
                                                    </div>
                                                    <div className='py-2'>
                                                        <strong>Nível:</strong> {selection.paylevel.grade.title}
                                                    </div>
                                                    <div className='py-2'>
                                                        <strong>Moeda:</strong> {selection.paylevel.currency}
                                                    </div>
                                                    <div className='py-2'>
                                                        <strong>Frequêcia:</strong> {selection.paylevel.frequency}
                                                    </div>
                                                    <div className='py-2'>
                                                        <strong>Salário Base:</strong> {currencyFormat(selection.paylevel.amount)}
                                                    </div>
                                                    <div className='py-2'>
                                                        <strong>Faixa Salarial:</strong> {
                                                                    selection.paylevel.range.filter((range, index) => index === 0).map(obj => 
                                                                        currencyFormat(obj.value)
                                                                    )
                                                                }
                                                                <span> - </span>
                                                                {
                                                                    selection.paylevel.range.filter((range, index) => index === 2).map(obj => 
                                                                        currencyFormat(obj.value)
                                                                    )
                                                                }
                                                    </div>
                                                    </>
                                                    :
                                                    <div className='py-2'>
                                                        <strong>Estrutura de Salário: </strong> Nenhum salário cadastrado
                                                    </div>
                                                }
                                                <div className='py-3'>
                                                    <strong>Benefícios {selection.benefits.length > 0 ? <>({selection.benefits.length})</> : null}</strong>
                                                    
                                                    {
                                                        selection.benefits.length > 0 ?
                                                        <div className="d-flex flex-nowrap gap-2 mt-2">
                                                        {
                                                            selection.benefits.map((item, index) => 
                                                                <Chip key={index} label={item.title} />
                                                            )
                                                        }
                                                        </div>
                                                        :
                                                        <p>
                                                        Nenhum benefício adicionado
                                                        </p>
                                                    }
                                                </div>
                                            </div>
                                            }
                                            </>
                                            :null
                                        }
                                    </Sidebar>
                                </div>
                            </div>
                            <div id="formImport" className="modal fade" ref={modalRef}>
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Importar Posições</h5>
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                            
                                            <div className='mb-3'>
                                                <p>
                                                    Utilize e planilha modelo para importar 
                                                </p>
                                                <a href={worksheet} target='_blank' rel="noopener noreferrer" className='btn btn-sm btn-success'>
                                                    Planilha Modelo
                                                </a>
                                            </div>
                                                <FormImportJobPositionXls hideModal={hideModal} />
                                            <hr/>
                                        </div>
                                        <div className='modal-footer'>
                                            <button type="button" className="btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </>
                            :
                            <p className='alert alert-warning m-3'>Você não tem permissão para acessar esta página</p>
                        }
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}